/** Keep the onboarding conversion flow in Ink without changing the app preference.
 * Keep the before-paint policy in index.html aligned with this function.
 */
export function isInkOnlyOnboardingRoute(pathname: string, search = '', isNativeRuntime = false): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/onboarding' || (path === '/' && isNativeRuntime)) return true;
  const params = new URLSearchParams(search);
  if (path === '/complete-account') {
    return params.get('reason') === 'purchase' || params.get('reason') === 'free';
  }
  return path === '/welcome-premium' && params.get('onboarding') === 'complete';
}
